import SuiBox from "components/SuiBox";

import MaterialLibrary from "pages/unionwear/components/MaterialLibrary";
import UnionwearLayout from "pages/unionwear/layout";

const UnionwearMaterialPage = () => {
  return (
    <SuiBox>
      <UnionwearLayout>
        <MaterialLibrary />
      </UnionwearLayout>
    </SuiBox>
  );
};

export default UnionwearMaterialPage;
